<app-notification-template-view *ngIf="data && !canEdit" [data]="data"></app-notification-template-view>
<app-notification-template-edit *ngIf="data && canEdit" [data]="data"></app-notification-template-edit>

<div class="wrapper-md" *ngIf="error">
    <app-breadcrumbs [items]="[{ url: '/notification-templates', text: 'notificationTemplate_listTitle' }]"></app-breadcrumbs>
    <app-alert level="danger" *ngIf="error">{{error}}</app-alert>
</div>
